import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { ReviewMetadataColumn, ReviewMetadataRow, StyledMetadataValue } from 'automation-ui-canvas/containers/review/StyledMetadataDetails';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UserName from 'automation-ui-references/customer-data/UserName';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateMetadata = ({
  flow
}) => {
  var _flow$createMetadata, _flow$createMetadata2;
  const userId = flow === null || flow === void 0 || (_flow$createMetadata = flow.createMetadata) === null || _flow$createMetadata === void 0 || (_flow$createMetadata = _flow$createMetadata.updatedBy) === null || _flow$createMetadata === void 0 ? void 0 : _flow$createMetadata.userId;
  const updatedAt = flow === null || flow === void 0 || (_flow$createMetadata2 = flow.createMetadata) === null || _flow$createMetadata2 === void 0 ? void 0 : _flow$createMetadata2.updatedAt;
  return /*#__PURE__*/_jsxs(ReviewMetadataRow, {
    children: [/*#__PURE__*/_jsxs(ReviewMetadataColumn, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.detailsStep.create"
        })
      }), /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: updatedAt ? /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
          value: updatedAt,
          hideSeconds: true,
          format: 'lll'
        }) : '--'
      })]
    }), /*#__PURE__*/_jsxs(ReviewMetadataColumn, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.detailsStep.createdBy"
        })
      }), /*#__PURE__*/_jsx(StyledMetadataValue, {
        children: userId ? /*#__PURE__*/_jsx(UserName, {
          id: userId
        }) : '--'
      })]
    })]
  });
};
export default CreateMetadata;